import _ from 'lodash'
import React, { Fragment } from 'react'
import { compose, bindActionCreators } from 'redux'
import injectSheet from 'react-jss'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import qs from 'qs'
import Navbar from './Navbar'
import Broadcast from './Broadcast'
import InfoCard from './Card/InfoCard'
import OpeningCard from './Card/OpeningCard'
import BottomNavigation from './BottomNavigation'
import PoweredBy from './PoweredBy'
import Intro from './Dialog/Intro'
import Share from './Dialog/Share'
import StoreDelivery from './Dialog/StoreDelivery'
import Takeaway from './Dialog/Takeaway'
import BackdropLoading from './BackdropLoading'
import ScrollToBottomButton from './Button/ScrollToBottomButton'
import CategoryDetailContainer from 'containers/components/CategoryDetail'

import opacity from '../../../constants/opacity'
import * as userActions from '../../../actions/components/user'
import * as directoryActions from '../../../actions/components/directory'

class DirectoryPage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isBottom: false,
      canScroll: false,
      shouldShowPromoImage: true,
      promoImageUrl: 'https://img.dimorder.com/1024x/public/Landing_Banner/%E6%8E%A8%E8%96%A6%E6%9C%8B%E5%8F%8B%E7%A2%BC_11-3-2022-01.png',
    }
    this.contentEndRef = null
    this.breakpoints = { sm: 375 }
  }

  handleResize = () => {
    const screenWidth = window.screen.width
    if (screenWidth < this.breakpoints.sm) {
      this.props.updateScale('xs')
    } else {
      this.props.updateScale('sm')
    }
    this.handleDocumentScroll()
  }

  handleDocumentScroll = () => {
    const scrollTop = document.documentElement.scrollTop
    const scrollHeight = document.documentElement.scrollHeight
    const clientHeight = document.documentElement.clientHeight
    const isBottom = scrollTop >= scrollHeight - clientHeight - 80 // leave a 80px buffer
    const canScroll = scrollHeight > clientHeight

    if (!canScroll) {
      this.setState({ isBottom: true })
    } else {
      // canScroll
      if (isBottom && !this.state.isBottom) {
        this.setState({ isBottom: true })
      }
      if (!isBottom && this.state.isBottom) {
        this.setState({ isBottom: false })
      }
    }
  }

  componentDidMount = async () => {
    // If permissions has ':waiter', logout user.
    const { user, location } = this.props
    const params = qs.parse(location.search.slice(1))
    const isLoginWaiter = _.get(user, 'permissions', []).some(p => p.includes(':waiter'))
    if (isLoginWaiter && params.m) {
      this.props.logout()
    }
    window.addEventListener('resize', this.handleResize)
    document.addEventListener('scroll', this.handleDocumentScroll)
  }

  componentDidUpdate = (prevProps) => {
    const { merchant } = this.props
    if (!prevProps.merchant && merchant) {
      this.handleResize()
      setTimeout(() => this.props.updateDisplayIntro(false), 1000)
    }
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.handleResize)
    document.removeEventListener('scroll', this.handleDocumentScroll)
  }

  scollToBottom = () => {
    this.contentEndRef.scrollIntoView({ behavior: 'smooth' })
  }

  render () {
    const { classes, merchant } = this.props
    const { isBottom } = this.state
    if (!merchant || !merchant.setting) return null
    const backgroundImage = merchant.setting.directoryBackgroundImage

    return (
      <Fragment>
        <div className={classes.content} >
          <section>
            <Navbar merchantName={merchant.name} />
            <Broadcast />
            <InfoCard />
            <OpeningCard />
            <BottomNavigation />
          </section>
          <div
            style={{ alignSelf: 'center' }}
            ref={ref => { this.contentEndRef = ref }}
          >
            <PoweredBy />
          </div>
        </div>
        <div className={classes.backgroundMask} />
        <div className={classes.background} style={{ backgroundImage: `url(${backgroundImage})` }} />

        <ScrollToBottomButton display={!isBottom} onClick={this.scollToBottom} />

        {/* Dialogs */}
        <Intro />
        <Share />
        <StoreDelivery />
        <Takeaway />
        <BackdropLoading />
        <CategoryDetailContainer
	        shouldShowPromoImage={this.state.shouldShowPromoImage}
	        promoImageUrl={this.state.promoImageUrl}
	        onPromoImageClose={() => {
	          this.setState({
	            shouldShowPromoImage: false,
	          })
	        }}
          hideClose
	      />
      </Fragment>
    )
  }
}

const styles = {
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overflow: 'hidden',
    padding: '8px 16px',
    '& > section': {
      flexShrink: 0,
      display: 'flex',
      flexDirection: 'column',
    },
    '& > section > div': {
      flexShrink: 0,
      margin: '12px 0px',
    },
    '& > section > div:first-child': {
      // Navbar
      marginTop: 0,
      marginBottom: 0,
    },
    '& > section > div:last-child': {
      // BottomNavigation
      marginBottom: 120,
    },
  },
  backgroundMask: {
    zIndex: -9,
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    backgroundColor: '#292929' + opacity[50],
    // filter: 'blur(170px)',
    backdropFilter: 'blur(40px)', // The parameter of blur function is a radius, which cannot over either the half of the height or width.
    overflow: 'hidden',
  },
  background: {
    zIndex: -10,
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    backgroundColor: '#525252' + opacity[60],
    // filter: 'blur(170px)',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    overflow: 'hidden',
  },
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    merchant: state.merchant,
    directory: state.directory,
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(userActions, dispatch),
  ...bindActionCreators(directoryActions, dispatch),
})

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectSheet(styles),
  injectIntl,
)(DirectoryPage)



// WEBPACK FOOTER //
// ./src/components/scenes/DirectoryPage/index.jsx